module.exports = __webpack_public_path__ + "img/5.9366703a.png";